<template lang="pug">
header.Header(:class="{ isMobile }")
  p.title
    a(@click="click") Rezo Zero
  p.look-further(v-if="!$store.state.loaderIsVisible") {{$t('look_further')}}
  p.wishes(v-if="!$store.state.loaderIsVisible") {{$t('wishes_2020')}}
</template>

<script>
export default {
  name: 'Header',
  props: ['isMobile'],
  methods: {
    click (e) {
      if (this.$route.name !== 'home') {
        if (this.$route.name === 'single-card') {
          this.$store.commit('fixCursor', false)
          this.$store.commit('hover', false)
        }
        if (this.$route.name === 'finale') {
          for (let card of this.$store.state.cards) {
            card.hasBeenVisited = false
          }
        }
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 24px;
  height: 70px;
  z-index: 100;

  &.isMobile {
    justify-content: space-between;
    p { margin: 0 }
  }

  p {
    font-family: $font-rz;
    font-size: 16px;
    font-weight: normal;
    padding: 0;
    margin: 0;
    color: currentColor;
    opacity: .5;
    margin-right: 24px;

    &.title {
      opacity: 1;
    }

    a {
      color: currentColor;
      text-decoration: none;
      cursor: pointer;
    }

    &.wishes {
      position: absolute;
      right: 24px;
      top: 27px;

      font-family: $font-rz;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.15em;

      @media (min-width: 780px) {
        top: 50vh;
        right: 10px;
        transform: translate(50%, -50%) rotate(90deg);
      }
    }

    &.look-further {
      @media (max-width: 779px) {
        display: none;
      }
    }
  }

}
</style>
